import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=2fa21eb8&scoped=true&"
import script from "./ThirdSection.vue?vue&type=script&lang=js&"
export * from "./ThirdSection.vue?vue&type=script&lang=js&"
import style0 from "./ThirdSection.vue?vue&type=style&index=0&id=2fa21eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa21eb8",
  null
  
)

export default component.exports